// extracted by mini-css-extract-plugin
export default {"cookiesBanner":"ezlSTYUE","link":"QTstipHq"};